import React from 'react'
import { InputsContainer } from '../../../ui/form'
import { FORM_TEXTS } from '../constants'
import Input from '../../../ui/input'
import Select from '../../../ui/select'
import Autocomplete from '../../../ui/autoComplete'

const SignUpStep3 = ({
  values, errors, touched, handleChange, handleBlur, setFieldValue,
  healthInsuranceOptions, planOptions, getHealthInsurancePlans
}) => (
  <InputsContainer gap={24} mb={16}>
    <Autocomplete
      label={FORM_TEXTS.labels.healthInsurance}
      name="healthInsurance"
      value={values.healthInsurance}
      lightGrey
      options={healthInsuranceOptions}
      placeholder={FORM_TEXTS.placeholders.healthInsurance}
      error={touched.healthInsurance && errors.healthInsurance}
      assignFieldValue={value => {
        setFieldValue('healthInsurance', value)
        setFieldValue('plan', '')
        getHealthInsurancePlans(value)
      }}
    />
    {planOptions?.length > 0 && (
      <Select
        label={FORM_TEXTS.labels.plan}
        name="plan"
        value={values.plan}
        onChange={e => setFieldValue('plan', e.target?.value || e)}
        options={planOptions}
        placeholder={FORM_TEXTS.placeholders.plan}
        error={touched.plan && errors.plan}
      />
    )}
    <Input
      label={FORM_TEXTS.labels.credentialNumber}
      name="credentialNumber"
      placeholder={FORM_TEXTS.placeholders.credentialNumber}
      value={values.credentialNumber}
      onChange={handleChange}
      onBlur={handleBlur}
      error={touched.credentialNumber && errors.credentialNumber}
      fullWidth
    />
  </InputsContainer>
)

export default SignUpStep3